/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setLightBox.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

import LuminousGallery from "luminous-lightbox/lib/LuminousGallery";
import "luminous-lightbox/dist/luminous-basic.min.css"


/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(greenspark109)/g;

/**
 * lightbox
 */
function setLightbox() {

    window.addEventListener("DOMContentLoaded", () => {
        Box_gallery();
    });

    const Box_gallery = () => {
        var luminous_gallery = document.querySelectorAll('.luminous_gallery');
        if (luminous_gallery !== null) {
            new LuminousGallery(luminous_gallery);
        }
    }
    if (getPathName.match('greenspark109')) {

        window.addEventListener("DOMContentLoaded", () => {
            Box_1LDKA();
            Box_1LDKA_410();
            Box_1LDKB();
            Box_1LDKC();
            Box_1LDKC_607();
            Box_2LDKA1();
            Box_2LDKA2();
            Box_2LDKB1();
            Box_2LDKB1_603();
            Box_2LDKB1_1103();
            Box_2LDKB1_1303();
            Box_2LDKB2();
            Box_2LDKB2_1302();
            Box_3LDK();
            Box_safety1();
            Box_safety2();
            Box_safety3();
        });

        const Box_1LDKA = () => {
            var luminous_1LDKA = document.querySelectorAll('.luminous_1LDKA');
            if (luminous_1LDKA !== null) {
                new LuminousGallery(luminous_1LDKA);
            }
        }

        const Box_1LDKA_410 = () => {
            var luminous_1LDKA_410 = document.querySelectorAll('.luminous_1LDKA_410');
            if (luminous_1LDKA_410 !== null) {
                new LuminousGallery(luminous_1LDKA_410);
            }
        }

        const Box_1LDKB = () => {
            var luminous_1LDKB = document.querySelectorAll('.luminous_1LDKB');
            if (luminous_1LDKB !== null) {
                new LuminousGallery(luminous_1LDKB);
            }
        }

        const Box_1LDKC = () => {
            var luminous_1LDKC = document.querySelectorAll('.luminous_1LDKC');
            if (luminous_1LDKC !== null) {
                new LuminousGallery(luminous_1LDKC);
            }
        }

        const Box_1LDKC_607 = () => {
            var luminous_1LDKC_607 = document.querySelectorAll('.luminous_1LDKC_607');
            if (luminous_1LDKC_607 !== null) {
                new LuminousGallery(luminous_1LDKC_607);
            }
        }

        const Box_2LDKA1 = () => {
            var luminous_2LDKA1 = document.querySelectorAll('.luminous_2LDKA1');
            if (luminous_2LDKA1 !== null) {
                new LuminousGallery(luminous_2LDKA1);
            }
        }

        const Box_2LDKA2 = () => {
            var luminous_2LDKA2 = document.querySelectorAll('.luminous_2LDKA2');
            if (luminous_2LDKA2 !== null) {
                new LuminousGallery(luminous_2LDKA2);
            }
        }

        const Box_2LDKB1 = () => {
            var luminous_2LDKB1 = document.querySelectorAll('.luminous_2LDKB1');
            if (luminous_2LDKB1 !== null) {
                new LuminousGallery(luminous_2LDKB1);
            }
        }

        const Box_2LDKB1_603 = () => {
            var luminous_2LDKB1_603 = document.querySelectorAll('.luminous_2LDKB1_603');
            if (luminous_2LDKB1_603 !== null) {
                new LuminousGallery(luminous_2LDKB1_603);
            }
        }

        const Box_2LDKB1_1103 = () => {
            var luminous_2LDKB1_1103 = document.querySelectorAll('.luminous_2LDKB1_1103');
            if (luminous_2LDKB1_1103 !== null) {
                new LuminousGallery(luminous_2LDKB1_1103);
            }
        }
        const Box_2LDKB1_1303 = () => {
            var luminous_2LDKB1_1303 = document.querySelectorAll('.luminous_2LDKB1_1303');
            if (luminous_2LDKB1_1303 !== null) {
                new LuminousGallery(luminous_2LDKB1_1303);
            }
        }

        const Box_2LDKB2 = () => {
            var luminous_2LDKB2 = document.querySelectorAll('.luminous_2LDKB2');
            if (luminous_2LDKB2 !== null) {
                new LuminousGallery(luminous_2LDKB2);
            }
        }

        const Box_2LDKB2_1302 = () => {
            var luminous_2LDKB2_1302 = document.querySelectorAll('.luminous_2LDKB2_1302');
            if (luminous_2LDKB2_1302 !== null) {
                new LuminousGallery(luminous_2LDKB2_1302);
            }
        }

        const Box_3LDK = () => {
            var luminous_3LDK = document.querySelectorAll('.luminous_3LDK');
            if (luminous_3LDK !== null) {
                new LuminousGallery(luminous_3LDK);
            }
        }

        const Box_safety1 = () => {
            var luminous_safety1 = document.querySelectorAll('.luminous_safety1');
            if (luminous_safety1 !== null) {
                new LuminousGallery(luminous_safety1);
            }
        }
        const Box_safety2 = () => {
            var luminous_safety2 = document.querySelectorAll('.luminous_safety2');
            if (luminous_safety2 !== null) {
                new LuminousGallery(luminous_safety2);
            }
        }
        const Box_safety3 = () => {
            var luminous_safety3 = document.querySelectorAll('.luminous_safety3');
            if (luminous_safety3 !== null) {
                new LuminousGallery(luminous_safety3);
            }
        }
    }
    if (getPathName.match('town-hills-s')) {

        window.addEventListener("DOMContentLoaded", () => {
            Box_TownHillsS_floor1();
            Box_TownHillsS_floor2();
        });

        const Box_TownHillsS_floor1 = () => {
            var luminous_TownHillsS_floor1 = document.querySelectorAll('.luminous_town-hills-s_floor1');
            if (luminous_TownHillsS_floor1 !== null) {
                new LuminousGallery(luminous_TownHillsS_floor1);
            }
        }
        
        const Box_TownHillsS_floor2 = () => {
            var luminous_TownHillsS_floor2 = document.querySelectorAll('.luminous_town-hills-s_floor2');
            if (luminous_TownHillsS_floor2 !== null) {
                new LuminousGallery(luminous_TownHillsS_floor2);
            }
        }
    }
    if (getPathName.match('sport-training-center')) {

        window.addEventListener("DOMContentLoaded", () => {
            Box_gym01();
            Box_gym02();
            Box_gym03();
            Box_gym04();
            Box_gym05();
        });

        const Box_gym01 = () => {
            var luminous_gym01 = document.querySelectorAll('.luminous_gym01');
            if (luminous_gym01 !== null) {
                new LuminousGallery(luminous_gym01);
            }
        }
        const Box_gym02 = () => {
            var luminous_gym02 = document.querySelectorAll('.luminous_gym02');
            if (luminous_gym02 !== null) {
                new LuminousGallery(luminous_gym02);
            }
        }
        const Box_gym03 = () => {
            var luminous_gym03 = document.querySelectorAll('.luminous_gym03');
            if (luminous_gym03 !== null) {
                new LuminousGallery(luminous_gym03);
            }
        }
        const Box_gym04 = () => {
            var luminous_gym04 = document.querySelectorAll('.luminous_gym04');
            if (luminous_gym04 !== null) {
                new LuminousGallery(luminous_gym04);
            }
        }
        const Box_gym05 = () => {
            var luminous_gym05 = document.querySelectorAll('.luminous_gym05');
            if (luminous_gym05 !== null) {
                new LuminousGallery(luminous_gym05);
            }
        }
    }
}

export {
    setLightbox
}